import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const TermsOfService = () => (
    <Paper>
        <Stack spacing={2} className="center-children" sx={{ width: '80%', textAlign: 'center' }}>
            <Typography variant="h4">Terms of Service for Avron Quizzes</Typography>
            <br />
            <Typography variant="body1">
                Welcome to Avron Quizzes! These Terms of Service (the "Terms") govern your use of our quiz platform, website, and related
                services (collectively referred to as the "Services"). By accessing or using our Services, you agree to be bound by these
                Terms. If you do not agree to these Terms, please refrain from using our Services.
            </Typography>
            <Typography variant="h6">Acceptance of Terms</Typography>
            <Typography variant="body1">
                By accessing or using our Services, you acknowledge that you have read, understood, and agree to be bound by these Terms, as
                well as any additional terms and conditions that may apply to specific features or services within the platform. If you are
                using the Services on behalf of an organization, you represent and warrant that you have the authority to bind the
                organization to these Terms.
            </Typography>
            <Typography variant="h6">Use of Services</Typography>
            <Typography variant="body1">
                <ol style={{ listStyleType: 'lower-alpha' }}>
                    <li>
                        Eligibility: You must be at least 13 years old to use our Services. If you are under the age of 18, you confirm that
                        you have obtained parental or legal guardian consent to use the Services.
                    </li>
                    <li>
                        User Account: In order to access certain features of the Services, you may need to create a user account. You agree
                        to provide accurate and complete information during the registration process and to keep your account credentials
                        confidential. You are responsible for all activities that occur under your account.
                    </li>
                    <li>
                        Prohibited Activities: You agree not to use the Services for any unlawful or unauthorized purpose. This includes,
                        but is not limited to, engaging in any activity that could damage, disable, or impair the Services or interfere with
                        any other party's use of the Services.
                    </li>
                </ol>
            </Typography>
            <Typography variant="h6">Content</Typography>
            <Typography variant="body1">
                <ol style={{ listStyleType: 'lower-alpha' }}>
                    <li>
                        User-Generated Content: Our Services may allow you to submit, post, or transmit content, such as quiz questions,
                        answers, or comments ("User Content"). You retain ownership of any intellectual property rights in the User Content
                        that you submit. However, by submitting User Content, you grant us a non-exclusive, worldwide, royalty-free license
                        to use, copy, modify, distribute, and display the User Content for the purposes of operating and improving the
                        Services.
                    </li>
                    <li>
                        Prohibited Content: You agree not to submit or transmit any User Content that is unlawful, offensive, harmful,
                        defamatory, or infringes upon the rights of others. We reserve the right to remove any User Content that violates
                        these Terms or is otherwise objectionable.
                    </li>
                    <li>
                        Intellectual Property: The Services and all related intellectual property rights are owned by Avron Quizzes. You may
                        not use, reproduce, modify, or distribute any content from the Services without our prior written consent.
                    </li>
                </ol>
            </Typography>
            <Typography variant="h6">Privacy and GDPR Compliance</Typography>
            <Typography variant="body1">
                <ol style={{ listStyleType: 'lower-alpha' }}>
                    <li>
                        Data Collection and Processing: Avron Quizzes collects and processes personal data in accordance with the
                        requirements of the General Data Protection Regulation (GDPR). By using our Services, you acknowledge and consent to
                        the collection, storage, and processing of your personal data as outlined in our Privacy Policy.
                    </li>
                    <li>
                        User Rights: Under GDPR, you have the right to access, rectify, restrict, or delete your personal data. If you would
                        like to exercise any of these rights or have any concerns regarding the processing of your personal data, please
                        contact us using the information provided in our Privacy Policy.
                    </li>
                    <li>
                        Data Security: Avron Quizzes implements appropriate technical and organizational measures to ensure the security and
                        confidentiality of personal data. However, please be aware that no data transmission over the internet or storage
                        system can be guaranteed to be 100% secure.
                    </li>
                    <li>
                        Data Transfers: If Avron Quizzes transfers personal data outside the European Economic Area (EEA), we will ensure
                        appropriate safeguards are in place to protect the privacy and security of personal data, in compliance with GDPR
                        requirements.
                    </li>
                </ol>
            </Typography>
            <Typography variant="h6">Copyrights and User Responsibilities</Typography>
            <Typography variant="body1">
                <ol style={{ listStyleType: 'lower-alpha' }}>
                    <li>
                        Content Ownership: Avron Quizzes respects the intellectual property rights of others and expects its users to do the
                        same. Users are solely responsible for the content they submit or use through our Services, including but not
                        limited to images, videos, and any other copyrighted materials.
                    </li>
                    <li>
                        Legal Use of Content: Users must ensure that they have the necessary rights, licenses, or permissions to use and
                        share any content, including copyrighted materials, through our Services. Users agree not to submit or use any
                        content that infringes upon the rights of others, including copyright, trademark, or other proprietary rights.
                    </li>
                    <li>
                        Indemnification: Users agree to indemnify, defend, and hold Avron Quizzes harmless from any claims, damages, or
                        liabilities arising out of or related to the use of content that violates the copyrights or intellectual property
                        rights of others.
                    </li>
                    <li>
                        Reporting Copyright Infringement: Avron Quizzes respects the intellectual property rights of others and has a policy
                        to respond to notices of alleged copyright infringement in accordance with applicable laws. If you believe that any
                        content on our Services infringes your copyrights, please contact us using the information provided in our Copyright
                        Policy.
                    </li>
                </ol>
            </Typography>
            <Typography variant="h6">Modifications and Termination</Typography>
            <Typography variant="body1">
                We reserve the right to modify or terminate the Services, or any part thereof, at any time without prior notice. We may also
                update these Terms from time to time, and the updated version will be effective upon posting. Your continued use of the
                Services after any modifications to the Terms constitutes your acceptance of the modified Terms.
            </Typography>
            <Typography variant="h6">Disclaimer of Warranties</Typography>
            <Typography variant="body1">
                The Services are provided on an "as-is" and "as available" basis, without warranties of any kind, whether express or
                implied. Avron Quizzes does not warrant that the Services will be uninterrupted, error-free, or secure.
            </Typography>
            <Typography variant="h6">Limitation of Liability</Typography>
            <Typography variant="body1">
                To the maximum extent permitted by applicable law, Avron Quizzes and its affiliates shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or goodwill,
                arising out of or in connection with the use of the Services.
            </Typography>
            <Typography variant="h6">Governing Law and Jurisdiction</Typography>
            <Typography variant="body1">
                These Terms shall be governed by and construed in accordance with the laws of the jurisdiction where Avron Quizzes is
                located. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the
                courts in that jurisdiction.
            </Typography>
            <Typography variant="h6">Severability</Typography>
            <Typography variant="body1">
                If any provision of these Terms is found to be invalid, illegal, or unenforceable, the remaining provisions shall continue
                in full force and effect.
            </Typography>
            <Typography variant="h6">Entire Agreement</Typography>
            <Typography variant="body1">
                These Terms constitute the entire agreement between you and Avron Quizzes regarding the use of the Services and supersede
                any prior agreements or understandings, whether written or oral.
            </Typography>
            <Typography variant="body1">
                If you have any questions or concerns about these Terms, please contact us at{' '}
                <a href="mailto:avronquizzes@gmail.com">avronquizzes@gmail.com</a>. Thank you for using Avron Quizzes!
            </Typography>
        </Stack>
    </Paper>
);
